export default __webpack_public_path__ + "static/media/ok-check.d145cc95.svg";